module.exports = __webpack_public_path__ + "img/icon-card.032cc98f.svg";